<template>
  <a :href="premiumUrl" class="premium-banner no-underline" :class="isHorizon ? 'flex flex-row items-center' : 'text-center'">
    <premiumImage type="logo" class="mb-8"/>
    <div class="text-sm font-bold leading-normal" :class="isHorizon ? 'ml-16' : ''">
      <div>{{ $t('premium.title') }}</div>
      <div>
        <span>{{ $t('premium.text[0]') }}</span>
        <span class="text-premium">{{ $t('premium.text[1]') }}</span>
      </div>
    </div>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'premiumBanner',
  props: {
    isHorizon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      premiumUrl: 'user/premiumUrl'
    })
  }
}
</script>

<style lang="sass" scoped>
  .premium-banner
    @apply text-grey-darkest
</style>
